/**
 * VODCustom entity class
 */

/**
 * VODCustomFactory
 * returns VODCustom entity class
 *
 * @class VODCustomFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.VODCustom} class
 *
 * @ngdoc factory
 * @name mwApp.factory:VODCustomFactory
 */
/* @ngInject */
export default function VODCustomFactory ($http, VOD, alertLiteSvc) {
  /* === VODCustom class === */

  /**
   * VODCustom model
   *
   * @class VODCustom
   * @classdesc VODCustom model
   * @memberof models
   * @see models
   * @extends models.VOD
   * @return {models.VODCustom} VODCustom entity
   */
  function VODCustom () {
    var obj = VOD.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  VODCustom.prototype = Object.create(VOD.prototype)
  VODCustom.prototype.constructor = VODCustom

  /* === VODCustom instance methods & fields === */

  Object.assign(VODCustom.prototype, {

    /**
     * instance fields
     *
     * @memberof models.VODCustom#
     * @type {Object}
     */
    _fields: {
      ...VOD.prototype._fields,
      vod: 'VOD',
      $order: Boolean
    },

    /**
     * Patch method
     *
     * @memberof models.Episode#
     * @param {String} url
     * @param params
     * @return {Promise} promise
     * @private
     */
    _patch: function (url, params) {
      return $http.patch(url, params)
        .then(
          response => {
            if (response.data) {
              this._weakCopy(response.data)
            }
            return response
          }
        ).catch(
          rejection => {
            return alertLiteSvc.alertError(rejection)
          })
    },

    /**
     * On/Off Entity, performing PATCH request to the server
     *
     * @memberof models.Channel#
     * @param {Boolean} [enabled=this.enabled] - enable or disable Entity
     * @return {Promise} promise
     */
    _onOff: function (enabled) {
      if (typeof enabled !== 'boolean') {
        enabled = this.$order
      }

      return this._patch(this._url, enabled ? '"First"' : '"Last"')
        .catch(rejection => {
          this.$order = !this.$order
          return rejection
        })
    },

    /**
     * url template
     *
     * @memberof models.VODCustom#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{::subscriber.id}}/vods/{{::vod.id}}',

    /**
     * public url template,
     *
     * @memberof models.VODCustom#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{::subscriber.id}}/customstreams/{{::id ? "vod/" : "#vod"}}{{::id}}'

  })

  /* === VODCustom static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(VODCustom, VOD)
  VODCustom._name = 'VODCustom'
  VODCustom._publicName = 'Custom VOD'
  VODCustom.init()

  // permissions
  VODCustom.access = {
    view: 'viewSubscriberCustomStream',
    create: 'createSubscriberCustomStream',
    edit: 'editSubscriberCustomStream',
    delete: 'deleteSubscriberCustomStream'
  }

  // extra
  VODCustom.extra = {
    playbackTokenGenerators: ['PlaybackTokenGenerator'],
    categories: ['Category'],
    networks: ['Network'],
    drmProfiles: ['DRMProfile']
  }

  return VODCustom
}
